import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/ExploreButtons.css';

const ExploreButtons = () => {
  // The grid naturally renders as 3x3 (9 cells) only while the viewport is between 980px and
  // 1299px wide (auto-fit minmax(300px,1fr) math for the 1400px-max home-container). We keep 8
  // categories visible at all other sizes, and only add NDS back in during that narrow window so
  // the grid never ends up with an odd, unbalanced last row.
  const [showNds, setShowNds] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      const w = window.innerWidth;
      setShowNds(w >= 980 && w <= 1299);
    };
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  const categories = [
    { type: 'SteamGame', label: 'Explore Steam Game Collection', icon: '/static/icons/steam.svg' },
    { type: 'PSPGame', label: 'Explore PSP Game Collection', icon: '/static/icons/gamepad-solid.svg' },
    { type: 'VitaGame', label: 'Explore VITA Game Collection', icon: '/static/icons/playstation.svg' },
    { type: 'NDSGame', label: 'Explore NDS Game Collection', icon: '/static/icons/nintendo-ds.svg', hidden: !showNds },
    { type: 'ShowsAndMovies', label: 'Explore TV Shows & Movies', icon: '/static/icons/film-solid.svg' },
    { type: 'Anime', label: 'Explore Anime Collection', icon: '/static/icons/clapperboard-solid.svg' },
    { type: 'Manga', label: 'Explore Manga Collection', icon: '/static/icons/book-solid.svg' },
    { type: 'Book', label: 'Explore Books & Comics', icon: '/static/icons/book-solid.svg' },
    { type: 'Vinyl', label: 'Explore Vinyl Record Collection', icon: '/static/icons/record-vinyl-solid.svg' },
    { type: 'CD', label: 'Explore CD Collection', icon: '/static/icons/compact-disc-solid.svg' },
  ];

  return (
    <div className="explore-buttons">
      <h2>Explore Categories</h2>
      {categories.filter((cat) => !cat.hidden).map((cat) => (
        <Link key={cat.type} to={`/media-list/${cat.type}`} className="explore-button">
          <img src={cat.icon} className="icon" alt={cat.label} />
          {cat.label}
        </Link>
      ))}
    </div>
  );
};

export default ExploreButtons;